/* eslint-disable */
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdminOnline<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  slots = (params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminOnline/Slots`, method: "GET", secure: true, ...params });
  createSlot = (data: any, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminOnline/Slot`, method: "POST", body: data, secure: true, type: ContentType.Json, ...params });
  deleteSlot = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({ path: `/AdminOnline/Slot/${id}`, method: "DELETE", secure: true, ...params });
}
